export const GET_HOMEPAGE = "HOMEPAGE/GET_HOMEPAGE";
export const SET_FETCHING = "HOMEPAGE/SET_FETCHING";
